@let employees =
  employeesEc.plugins.currentListPlugin.feature.selectors.entities.asSignal();
@let selectedEmployees = selectedEmployeesSg();
@let employeeItems = employeeItemsSg();
@let error = bulkResponsiblePersonsPlugin.selectors.error.asSignal();
@let isSubmitting =
  bulkResponsiblePersonsPlugin.selectors.isSubmitting.asSignal();

<atn-ds-centered-overlay type="wide">
  <div class="atn-space-bulk-responsible-persons-modal">
    <atn-ds-widget [title]="titleSg()">
      <div actions>
        <i
          class="atn-icon atn-close atn-red"
          (click)="cancelClickHandler()"
        ></i>
      </div>

      <div class="atn-space-bulk-responsible-persons-modal__content">
        <atn-space-modal-employee-selector
          [employees]="employees"
          [selectedEmployees]="selectedEmployees"
          (employeeToggled)="employeeToggledHandler($event.id, $event.selected)"
          (employeeRemoved)="removeSelectedEmployee($event)"
        />

        @if (employeeItems.length > 0) {
          <atn-ds-select-single
            label="Primary Responsible Person"
            [items]="employeeItems"
            [value]="bulkResponsiblePersonsPlugin.selectors.primaryEmployeeId.asSignal()"
            (valueChange)="primaryEmployeeChangedHandler($event)"
          />
        }

        @if (error) {
          <atn-ds-notice
            [style]="DisplayStyle.Error"
            [description]="error.message"
          />
        }
      </div>

      <div
        class="atn-space-bulk-responsible-persons-modal__footer"
        footer
      >
        <atn-ds-button
          type="transparent"
          (click)="cancelClickHandler()"
          >Cancel</atn-ds-button
        >
        <atn-ds-button
          [disabled]="!selectedEmployees.length"
          [loading]="isSubmitting"
          (click)="saveClickHandler()"
          >Save</atn-ds-button
        >
      </div>
    </atn-ds-widget>
  </div>
</atn-ds-centered-overlay>
